import { useRequest } from 'hooks/useRequest';
import React from 'react';
import fetch from '@utils/fetch';
import Skeleton from './components/Skeleton';
import CardList from './components/CardList';
import { HashTagContent, HashTagRequest } from '@typings/hashtag';
import PostTemplate from './components/PostTemplate';
import { wakeUpApp } from '@utils/tools';
import BasicInfo from './components/BasicInfo';
import { getQueryString } from '@utils/schema';
import { ApiResponse } from '@typings/request';
// import mock from './common/mock';

const ID = getQueryString('id');

const DEFAULT_PARAMS = {
  count: 10,
  cursor: '',
  id: ID,
};
function Container() {
  const {
    loading,
    data = {
      status: 1,
      template_list: [],
    } as unknown as HashTagContent,
    err,
    run,
  } = useRequest(
    async () => {
      const res = await fetch.post<HashTagRequest, ApiResponse<HashTagContent>>(
        '/lv/v1/web/hashtag/get_hashtag_content',
        DEFAULT_PARAMS
      );
      return res.data;
    },
    {
      auto: true,
      initData: {
        status: 1,
        template_list: [],
      } as unknown as HashTagContent,
    }
  );
  const wake = () => {
    const url = `capcut://main/lynx?channel=image_lynx_hashtag_detail&bundle=template.js&theme=light&loading_bgcolor=ffffff&hide_nav_bar=1&status_bar_color=ffffff&status_font_dark=1&source=feed_detail_first&fe_id=${ID}`;
    wakeUpApp(url);
  };

  return (
    <div className="hashtag">
      <PostTemplate postTemplate={() => wake()} />
      {loading || err || data.status !== 1 ? (
        <Skeleton isErr={Boolean(err)} refresh={run} disable={data.status !== 1} />
      ) : (
        <>
          <BasicInfo element={data} />
          <CardList list={data.template_list} />
        </>
      )}
    </div>
  );
}

export default Container;
